export default "__VITE_ASSET___XhlwKLK__"